import type { MarketGroupData } from 'app/pages/MatchPage/types';

import {
  FIRST_SUPPREMACY_MARKETS_BY_VIDEOGAME,
  MARKET_GROUP_CATEGORY_WITHOUT_SUSPENSION,
  STAR_PLAYER_PREBUILT_TEMPLATES,
  TRADER_INPUT_INCREMENT_BY_VIDEOGAME_BY_CATEGORY
} from './markets.config';

const isFirstSuppDisplayed = (
  videogameSlug: VideogameSlug,
  group: MarketGroupData,
  category: string
) => {
  const { mainMarkets, markets } = group;
  const categoriesDisplayed = FIRST_SUPPREMACY_MARKETS_BY_VIDEOGAME[videogameSlug];

  if (categoriesDisplayed) {
    return (
      mainMarkets.find(
        item => item.id.includes('first') && categoriesDisplayed.includes(category)
      ) || markets.find(item => item.id.includes('first') && categoriesDisplayed.includes(category))
    );
  }

  return false;
};

const isStarPlayerMarketTemplate = (
  marketTemplate: string
): marketTemplate is PrebuiltMarketTemplate =>
  (STAR_PLAYER_PREBUILT_TEMPLATES as string[]).includes(marketTemplate);

const getMarketGroupsWithSuspension = (marketGroups: MarketGroupData[]): MarketGroupData[] =>
  marketGroups.filter(group => !MARKET_GROUP_CATEGORY_WITHOUT_SUSPENSION.includes(group.category));

const getTraderInputIncrementValue = (videogame: VideogameSlug, category: string) =>
  TRADER_INPUT_INCREMENT_BY_VIDEOGAME_BY_CATEGORY[videogame]?.[category] || 1;

export {
  isFirstSuppDisplayed,
  isStarPlayerMarketTemplate,
  getMarketGroupsWithSuspension,
  getTraderInputIncrementValue
};
